// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"4dbfbb8e","3325":"750daa37","5828":"4dbfbb8e","9892":"4dbfbb8e"}[chunkId] + ".chunk.css";
};